// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.message-text[data-v-5f874e94] {\n  white-space: pre-wrap;\n}\n.json-text[data-v-5f874e94] {\n  white-space: pre-wrap;\n}\n.url-text[data-v-5f874e94] {\n  white-space: pre-wrap;\n}\n", ""]);
// Exports
module.exports = exports;
